<template>
  <div class="dp-content">
    <div class="operations">
      <a
        href="https://school.jinritemai.com/buyin/web/article/102060"
        target="_blank"
        >投放说明</a
      >
      <el-dropdown trigger="click">
        <el-button type="primary">
          添加<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="visible = true"
            >优惠券码</el-dropdown-item
          >
          <el-dropdown-item>定向券</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <el-table :data="list" class="table" header-row-class-name="header">
      <el-table-column
        align="center"
        label="序号"
        width="51"
        label-class-name="index"
      >
        1
      </el-table-column>
      <el-table-column label="优惠券信息" width="218">
        <template slot-scope="{ row }">
          券名：{{ row.name }}<br />店铺：{{ row.storeName }}
        </template>
      </el-table-column>
      <el-table-column label="类型" width="150">
        <template slot-scope="{ row }">
          {{ row.typeDesc }}<br />{{ row.type }}
        </template>
      </el-table-column>
      <el-table-column label="领取条件" width="241">
        <template slot-scope="{ row }">
          {{ row.lqsj }}<br />{{ row.lqsl }}
        </template>
      </el-table-column>
      <el-table-column label="使用期限" width="194">
        <template slot-scope="{ row }">
          {{ row.sysjks }}至<br />{{ row.sysjjs }}
        </template>
      </el-table-column>
      <el-table-column label="数量" width="94" align="right" prop="num">
        <template slot-scope="{ row }">
          {{ row.num }}
          <template v-if="row.send">
            <br />
            <div class="send-tag">发放中</div>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140">
        <template slot-scope="{ row }">
          <template v-if="!row.send">
            <div class="o-btn" @click="dialogVisible = true">立即发券</div>
            <div class="o-btn" @click="remove">移除</div>
          </template>
          <div v-else class="o-btn" @click="row.send = false">结束发券</div>
        </template>
      </el-table-column>
      <div slot="empty" class="table-empty">
        <img
          src="https://lf3-fe.ecombdstatic.com/obj/ecom-cdn-default/ecom/marketing-buyin/image/coupon_empty.d85cdf59.png"
        />
        <div class="text">快去添加本场直播优惠券吧</div>
        <div class="addition">
          直播间可以同时发多批次优惠券啦，上限10个批次，每次发券默认每用户发1张
        </div>
      </div>
    </el-table>

    <el-drawer
      class="drawer"
      :visible.sync="visible"
      direction="rtl"
      title="添加优惠券码"
      :size="878"
      :wrapperClosable="false"
    >
      <div class="content">
        <div class="body">
          <div class="convert">
            <el-input
              class="input"
              v-model="code"
              placeholder="请输入19位优惠券批次号（可联系小店商家获取）"
              maxlength="19"
            ></el-input>
            <el-button
              class="btn"
              :disabled="!code || code.trim().length != 19"
              @click="queryCoupon"
              >获取</el-button
            >
          </div>
          <el-table
            :data="couponList"
            class="table"
            header-row-class-name="header"
          >
            <el-table-column
              label="优惠券信息"
              width="214"
              prop="name"
            ></el-table-column>
            <el-table-column label="类型" width="161">
              <template slot-scope="{ row }">
                {{ row.typeDesc }}<br />{{ row.type }}
              </template>
            </el-table-column>
            <el-table-column label="领取条件" width="209">
              <template slot-scope="{ row }">
                {{ row.lqsj }}<br />{{ row.lqsl }}
              </template>
            </el-table-column>
            <el-table-column label="使用期限" width="128">
              <template slot-scope="{ row }">
                {{ row.sysjks }}至<br />{{ row.sysjjs }}
              </template>
            </el-table-column>
            <el-table-column
              label="数量"
              prop="num"
              width="118"
            ></el-table-column>
            <div slot="empty" class="table-empty">
              <img
                src="https://lf3-fe.ecombdstatic.com/obj/ecom-cdn-default/ecom/marketing-buyin/image/msg_empty.8f041864.png"
              />
              <div class="addition">可联系小店商家获取优惠券</div>
            </div>
          </el-table>
        </div>
        <div class="footer">
          <div></div>
          <div>
            <el-button
              class="btn sub"
              type="primary"
              :disabled="couponList.length == 0"
              @click="add"
              >添加到直播</el-button
            >
            <el-button class="btn" @click="visible = false">取消</el-button>
          </div>
        </div>
      </div>
    </el-drawer>

    <el-dialog
      class="dialog"
      title="发放优惠券"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <span>立即向全员发券？</span>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn sub" @click="send">确 定</el-button>
        <el-button class="btn" @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { submit } from "@/api/chapterMock";

export default {
  data() {
    return {
      visible: false,
      list: [],

      dialogVisible: false,

      code: null,
      couponList: [],
    };
  },
  watch: {
    visible(val) {
      if (!val) {
        this.code = null;
        this.couponList = [];
      }
    },
  },
  methods: {
    queryCoupon() {
      this.couponList.push({
        code: this.code,
        name: "优惠券",
        storeName: "伊慕诺",
        type: "指定商品满减券",
        typeDesc: "满100减10元",
        lqsj: "2022/03/02至2022/03/19",
        lqsl: "每人限领1张",
        sysjks: "2022/03/02",
        sysjjs: "2022/03/19",
        num: "2张",
        send: false,
      });
      this.code = null;
    },
    add() {
      this.list = [...this.couponList];
      this.visible = false;
    },
    remove() {
      this.list = [];
    },
    send() {
      this.list[0].send = true;
      this.dialogVisible = false;
      const classChapterId = localStorage.getItem("mockChapterId");
      submit({
        classChapterId,
        content: JSON.stringify(this.list),
      }).then((res) => {
        this.$alert("提交成功", {
          confirmButtonText: "确定",
          callback: (action) => {
            window.close();
          },
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.dp-content {
  .operations {
    align-items: center;
    display: flex;
    justify-content: space-between;
    position: absolute;
    right: 0;
    top: 0;
    a {
      font-size: 14px;
      margin-right: 24px;
      color: #6557fa;
      cursor: pointer;
      outline: none;
      text-decoration: none;
      transition: color 0.3s;
    }

    &::v-deep  .el-button {
      padding: 6px 16px;
      background: #6557fa;
      border: 1px solid transparent;
      line-height: 18px;
    }
  }

  &::v-deep  .el-table {
    &::before {
      content: none;
    }
    .header {
      color: #515361;
    }
    th.el-table__cell > .cell {
      padding: 0 16px;
    }

    .el-table__cell {
      padding: 16px 0;
    }

    div.index {
      padding-right: 0 !important;
    }

    .el-table__empty-text {
      line-height: normal;
    }

    .o-btn {
      color: #6647ff;
      cursor: pointer;
      font-weight: 500;
    }

    .send-tag {
      display: inline-block;
      background-color: rgba(255, 159, 25, 0.1);
      border-radius: 2px;
      color: #ff9f19;
      font-size: 12px;
      height: 16px;
      line-height: 16px;
      text-align: center;
      width: 44px;
    }
  }

  .table-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      height: 223px;
      width: 320px;
    }

    .text {
      color: #12141a;
      font-size: 14px;
      line-height: 20px;
    }
    .addition {
      color: #85878a;
      font-size: 14px;
      line-height: 20px;
      margin-top: 8px;
    }
  }

  &::v-deep  .el-drawer__wrapper {
    .el-drawer__header {
      border-bottom: 1px solid #ebecf2;
      height: 54px;
      margin: 0;
      padding: 16px 24px;
      span {
        color: #131520;
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
      }
    }
  }

  .drawer {
    .content {
      display: flex;
      flex-direction: column;
      height: 100%;
      position: relative;
      .body {
        display: flex;
        flex: 1 1;
        flex-direction: column;
        overflow: auto;

        .convert {
          padding: 24px 24px 0;
          display: flex;
          align-items: center;

          .input {
            height: 32px;
            width: 748px;
            &::v-deep  .el-input__inner {
              line-height: 32px;
              height: 32px;
              &:focus {
                border-color: #6557fa;
              }
            }
          }

          .btn {
            width: 74px;
            height: 32px;
            margin-left: 8px;

            background: #6557fa;
            border: 1px solid transparent;
            box-shadow: none;
            color: #fff;
            font-size: 14px;
            padding: 0;
            &.is-disabled {
              background: #ececfe;
              border-color: transparent;
              color: #fff;
            }
          }
        }

        .table {
          padding: 24px 24px 0;
        }
      }
      .footer {
        align-items: center;
        border-top: 1px solid #edeff2;
        box-shadow: 0 -1px 3px 0 rgb(0 0 0 / 5%);
        display: flex;
        flex-shrink: 0;
        justify-content: space-between;
        margin-top: 16px;
        min-height: 64px;
        padding: 0 24px;

        .btn {
          height: 32px;
          width: 74px;
          box-shadow: none;
          font-size: 14px;
          padding: 0;
          color: #12141a;
        }

        .sub {
          width: 102px;
          background: #6557fa;
          border: 1px solid transparent;
          color: #fff;
          &.is-disabled {
            background: #ececfe;
            border-color: transparent;
            color: #fff;
          }
        }
      }
    }
  }

  .dialog {
    .btn {
      height: 32px;
      width: 74px;
      box-shadow: none;
      font-size: 14px;
      padding: 0;
      color: #12141a;
    }

    .sub {
      background: #6557fa;
      border: 1px solid transparent;
      color: #fff;
    }
  }
}
</style>